module.exports = __webpack_public_path__ + "db70d0b9cb27ada1a260a2b35e756b8b.woff";